/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardLimitRefundResponseViewModel } from "../types/CreditCardLimitRefundResponseViewModel.ts";

export const creditCardLimitRefundResponseViewModelSchema = z.object({
  id: z.optional(z.string().uuid()),
  refundAmount: z.optional(z.number()),
  createdAt: z.optional(z.string().datetime()),
  refundAt: z.optional(z.string().datetime()),
  debitDate: z.optional(z.string().datetime()),
  status: z.string().nullish(),
}) as unknown as ToZod<CreditCardLimitRefundResponseViewModel>;
